<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="vx-row">
      <vx-card>
        <div class="vx-row text-sm">
          <div class="vx-col sm:w-full md:w-full lg:w-2/12">
            <div class="list-heading mr-2">
              {{ $t("customers.label.customers") }}
            </div>
          </div>
          <div
            class="vx-col sm:w-full md:w-full mb-1 header--customerlist md:w-10 lg:w-10/12"
          >
            <ul class="horizontal-sm-btn flex justify-end gap-3 mb-2">
              <li>
                <div class="cursor-pointer font-small w-full mt-1">
                  <v-select
                    label="text"
                    v-model="searchOption"
                    :reduce="(obj) => obj.value"
                    :placeholder="$t('customers.label.SelectType')"
                    :options="searchItems"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-100 w-full"
                  />
                </div>
              </li>
              <li>
                <div
                  class="cursor-pointer flex items-center font-small w-full mt-1"
                >
                  <vs-input
                    type="text"
                    class="w-100 search-inp"
                    icon-pack="feather"
                    icon="icon-search"
                    :disabled="!searchOption"
                    icon-no-border
                    :placeholder="SearchPlaceholder"
                    @keyup.enter="searchCustomer"
                    v-model="searchdata"
                  />
                </div>
              </li>
              <li>
                <div
                  class="cursor-pointer flex items-center text-lg font-medium w-full"
                >
                  <vs-button
                    icon-pack="feather"
                    icon="icon-search"
                    type="border"
                    size="small"
                    @click="onClickAdvanceSearch"
                    >{{ $t("customers.label.advance_search") }}
                  </vs-button>
                </div>
              </li>
              <li>
                <div
                  class="cursor-pointer flex items-center text-lg font-medium w-full"
                >
                  <vs-button
                    icon-pack="feather"
                    size="small"
                    icon="icon-archive"
                    type="border"
                    @click="$router.push({ name: 'Customer Activation' })"
                  >
                    {{ $t("customers.label.customer_activation") }}
                  </vs-button>
                </div>
              </li>
              <li>
                <div
                  class="cursor-pointer flex items-center text-lg font-medium w-full"
                >
                  <vs-button
                    icon-pack="feather"
                    size="small"
                    icon="icon-plus"
                    @click="$router.push({ name: 'Create Customer' })"
                  >
                    {{ $t("customers.label.create_customer") }}
                  </vs-button>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <vs-table
          :max-items="10"
          pagination
          v-if="customerListToggleValue == true"
          :data="getCustomers"
          @selected="handleSelected"
        >
          <template slot="thead">
            <vs-th>{{ $t("customers.label.account_no") }}</vs-th>
            <vs-th>{{ $t("customers.label.customer_name") }}</vs-th>
            <vs-th>{{ $t("customers.label.business_entity") }}</vs-th>
            <vs-th>{{ $t("customers.label.serial_no") }}</vs-th>
            <vs-th>{{ $t("Type") }}</vs-th>
            <vs-th>{{ $t("customers.label.status") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="customer"
              v-for="(customer, index) in data"
            >
              <vs-td :data="customer.accountNo">{{ customer.accountNo }}</vs-td>

              <vs-td :data="customer.displayName">{{
                customer.displayName || customer.firstname
              }}</vs-td>
              <vs-td :data="customer.officeName">{{
                customer.officeName
              }}</vs-td>
              <vs-td :data="customer.hwSerialNumber">{{
                customer.hwSerialNumber
              }}</vs-td>
              <vs-td :data="customer.type">
                <vs-chip
                  :color="getOrderTypeColor(customer.type)"
                  class="product-order-status"
                  >{{ customer.type }}
                </vs-chip>
              </vs-td>
              <vs-td :data="customer.status.value">
                <vs-chip
                  :color="getOrderStatusColor(customer.status.value)"
                  class="product-order-status"
                  >{{ customer.status.value }}
                </vs-chip>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div v-if="customerListToggleValue == false">
          <div class="full-search">
            <vs-input
              v-model="searchQuery"
              placeholder="Account No / Sim No / Contact Mobile No / Email Id"
              class="full-width-input"
              @input="performSearch"
            />
            <vs-button
              @click="performSearch"
              type="filled"
              class="text-center mt-5"
              color="primary"
            >
              {{ $t("customers.label.search") }}
            </vs-button>
          </div>
          <vs-table
            :max-items="10"
            pagination
            :data="customerFullSearchDetails"
            @selected="handleSelected"
            v-if="searchQuery"
          >
            <template slot="thead">
              <vs-th>{{ $t("customers.label.account_no") }}</vs-th>
              <vs-th>{{ $t("customers.label.customer_name") }}</vs-th>
              <vs-th>{{ $t("customers.label.business_entity") }}</vs-th>
              <vs-th>{{ $t("customers.label.serial_no") }}</vs-th>
              <vs-th>{{ $t("customers.label.balance") }}</vs-th>
              <vs-th>{{ $t("customers.label.status") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="customer"
                v-for="(customer, index) in data"
              >
                <vs-td :data="customer.accountNo">{{
                  customer.accountNo
                }}</vs-td>

                <vs-td :data="customer.displayName">{{
                  customer.displayName
                }}</vs-td>
                <vs-td :data="customer.officeName">{{
                  customer.officeName
                }}</vs-td>

                <vs-td :data="customer.hwSerialNumber">{{
                  customer.hwSerialNumber
                }}</vs-td>
                <vs-td :data="customer.balanceAmount">{{
                  customer.balanceAmount
                }}</vs-td>
                <vs-td :data="customer.status.value">
                  <vs-chip
                    :color="getOrderStatusColor(customer.status.value)"
                    class="product-order-status"
                  >
                    {{ customer.status.value }}
                  </vs-chip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-table
            :max-items="1"
            :data="getCustomers"
            @selected="handleSelected"
            v-if="
              searchOption &&
              searchdata &&
              customerListToggleValue == false &&
              getCustomers.length > 0
            "
          >
            <template slot="thead">
              <vs-th>{{ $t("customers.label.account_no") }}</vs-th>
              <vs-th>{{ $t("customers.label.customer_name") }}</vs-th>
              <vs-th>{{ $t("customers.label.business_entity") }}</vs-th>
              <vs-th>{{ $t("customers.label.serial_no") }}</vs-th>
              <vs-th>{{ $t("customers.label.balance") }}</vs-th>
              <vs-th>{{ $t("customers.label.status") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="customer"
                v-for="(customer, index) in data"
              >
                <vs-td :data="customer.accountNo">{{
                  customer.accountNo
                }}</vs-td>

                <vs-td :data="customer.displayName">{{
                  customer.displayName
                }}</vs-td>
                <vs-td :data="customer.officeName">{{
                  customer.officeName
                }}</vs-td>

                <vs-td :data="customer.hwSerialNumber">{{
                  customer.hwSerialNumber
                }}</vs-td>
                <div
                  :class="getBalanceClass(customer.balanceAmount)"
                  style="color: red; background-color: yellow"
                >
                  {{ customer.balanceAmount }}
                </div>
                <vs-td :data="customer.status.value">
                  <vs-chip
                    :color="getOrderStatusColor(customer.status.value)"
                    class="product-order-status"
                  >
                    {{ customer.status.value }}
                  </vs-chip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('customers.label.advance_search')"
          :active.sync="advancedSearchPopup"
          class="popup-close"
        >
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  :label-placeholder="$t('customers.label.first_name')"
                  type="text"
                  class="w-full font-semibold mb-2"
                  icon-pack="feather"
                  icon="icon-search"
                  icon-no-border
                  v-model="search.firstName"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  :label-placeholder="$t('customers.label.last_name')"
                  type="text"
                  class="w-full font-semibold mb-2"
                  icon-pack="feather"
                  icon="icon-search"
                  icon-no-border
                  v-model="search.lastName"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  :label-placeholder="$t('customers.label.city_area')"
                  type="text"
                  class="w-full font-semibold mb-2"
                  icon-pack="feather"
                  icon="icon-search"
                  icon-no-border
                  v-model="search.city"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  :label-placeholder="$t('customers.label.email')"
                  type="text"
                  class="w-full font-semibold mb-2"
                  icon-pack="feather"
                  icon="icon-search"
                  icon-no-border
                  v-model="search.email"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  :label-placeholder="$t('customers.label.phone')"
                  type="text"
                  class="w-full font-semibold mb-2"
                  icon-pack="feather"
                  icon="icon-search"
                  icon-no-border
                  v-model="search.phone"
                />
              </div>
              <!-- <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  :label-placeholder="$t('label.input.entitycode')"
                  type="text"
                  class="w-full font-semibold mb-2"
                  icon-pack="feather"
                  icon="icon-search"
                  icon-no-border
                  v-model="search.officeId"
                />
              </div> -->
              <div class="vx-col sm:w-1/2 w-full">
                <vue-simple-suggest
                  v-model="loc"
                  :placeholder="$t('customers.label.enter_business_entity')"
                  :list="locList"
                  @input="testMethod2()"
                  class="w-full font-normal mb-2 mt-8"
                  :filter-by-query="true"
                >
                  <div slot="suggestion-item" slot-scope="{ suggestion }">
                    <span @click="changeLoc(suggestion.id)"
                      >{{ suggestion.externalId }} --
                      {{ suggestion.name }}</span
                    >
                  </div>
                </vue-simple-suggest>
              </div>

              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  :label-placeholder="$t('customers.label.cafid')"
                  type="text"
                  class="w-full mb-2 font-semibold"
                  icon-pack="feather"
                  icon="icon-search"
                  icon-no-border
                  v-model="search.externalId"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <v-select
                  label="categoryType"
                  v-model="search.categoryType"
                  :placeholder="$t('customers.label.select_category_type')"
                  :options="getCustomerTemplate.clientCategoryDatas"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 mt-8 w-full vs-search-categeory font-semibold"
                />
                <!-- <vs-select
                  class="selectExample w-full vs-search-categeory"
                  v-model="search.categoryType"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.categoryType"
                    v-for="(item,index) in getCustomerTemplate.clientCategoryDatas"
                  />
                </vs-select> -->
              </div>
            </div>

            <div class="vx-row justify-center my-4">
              <span class="ml-4 mr-1">
                <vs-button
                  icon-pack="feather"
                  type="border"
                  icon="icon-x"
                  @click="clearSearch"
                  >{{ $t("customers.label.clear") }}</vs-button
                >
              </span>
              <span class="ml-1 mr-2">
                <vs-button
                  icon-pack="feather"
                  icon="icon-search"
                  @click="advanceSearch"
                >
                  {{ $t("customers.label.search") }}
                </vs-button>
              </span>
            </div>
          </form>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import _ from "lodash";
import vSelect from "vue-select";
import VueSimpleSuggest from "vue-simple-suggest";
import { mapState, mapMutations } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  data() {
    return {
      loading: false,
      user_data: null,
      searchdata: "",
      loc: "",
      user_not_found: false,
      searchQuery: "",
      searchOption: null,
      descriptionItems: [5, 10, 15],
      searchItems: [
        { text: this.$t("customers.label.AccountNo"), value: "account_no" },
        { text: this.$t("MSISDN"), value: "serial_no" },
        { text: this.$t("customers.label.EmailId"), value: "email" },
        // {
        //   text: this.$t("customers.label.ChipId"),
        //   value: "provisioning_serialno",
        // },
        { text: this.$t("Contact No"), value: "phone" },
        
        
        // { text: this.$t("customers.label.LegacyNo"), value: "external_id" },
      ],
      search: {
        firstName: "",
        lastName: "",
        city: "",
        email: "",
        phone: "",
        officeId: "",
        categoryType: "",
        externalId: "",
        limit: 1000,
      },
      advancedSearchPopup: false,
    };
  },
  components: {
    AtomSpinner,
    "v-select": vSelect,
    VueSimpleSuggest,
    flatPickr,
  },
  computed: {
    SearchPlaceholder() {
      if (this.searchOption === "account_no") {
        return this.$t("customers.label.account_no");
      } else if (this.searchOption === "phone") {
        return this.$t("customers.label.mobile_no");
      } else if (this.searchOption === "email") {
        return this.$t("customers.label.email_id");
      } else if (this.searchOption === "serial_no") {
        return this.$t("customers.label.msisdn");
      } else return this.$t("customers.label.searchclient");
    },
    getCustomers() {
      return this.$store.getters["customer/getClientsList"];
    },
    getCustomerTemplate() {
      return this.$store.getters["customer/getClientsTemplate"];
    },
    ...mapState({
      locList: (state) => state.entity.locationList,
      customerFullSearchDetails: (state) =>
        state.customer.customerFullSearchData,
      customerListToggleValue: (state) => state.settings.isCustomerListActive,
    }),
  },
  methods: {
    testMethod2() {
      let temp = this.loc;
      if (temp.includes("{")) {
        temp = JSON.parse(temp);

        if (typeof temp === "object") {
          this.loc = temp.externalId + "--" + temp.name;
          this.search.officeId = temp.id;
        }
      } else {
        this.$store.dispatch("entity/entityGetLocationAction", this.loc);
      }
    },
    formatAccountNumber(accountInput) {
      let inputStr = accountInput.toString();
      if (inputStr.substring(0, 3).toUpperCase() === "CR-") {
        return inputStr;
      }
      const totalDigits = 9;

      let paddedNumber = inputStr.padStart(totalDigits, "0");
      return "CR-" + paddedNumber;
    },

    ...mapMutations("customer", ["CLEAR_CLIENTS_LIST"]),
    async searchCustomer() {
      try {
        const payload = {
          type: this.searchOption,
          val: this.searchdata.trim(),
        };
        if (this.searchOption === "account_no") {
          payload.val = this.formatAccountNumber(this.searchdata.trim());
        }
        await this.$store.dispatch("customer/setCustomerSearch", payload);
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "warning",
          html: "<div style='text-align:center;'>Unfortunately, we couldn't find a match with the given information.</div>",
          type: "warning",
        });
      }
      if (e === "Backspace" && this.customerListToggleValue == true) {
        this.getCustomer(this.searchdata);
      }
      if (e === "Backspace" && this.customerListToggleValue == false) {
        this.CLEAR_CLIENTS_LIST();
      }
      if (this.customerListToggleValue == false) {
        this.CLEAR_CLIENTS_LIST();
      }
    },
    getBalanceClass(balanceAmount) {
      return balanceAmount >= 0 ? "positive-balance" : "negative-balance";
    },
    getOrderStatusColor(status) {
      if (status === "Inactive") return "dark";
      if (status === "New") return "warning";
      return "success";
    },
    getOrderTypeColor(type) {
      if (type === "Prepaid") return "success";
      if (type === "Postpaid") return "warning";
      return "dark";
    },
    handleSelected(item) {
      this.$router.push({ path: `/customers/view_customer/${item.id}` });
    },
    async getCustomer(queryParams) {
      try {
        this.$store.dispatch(
          "customer/setClient",
          _.pickBy(queryParams, _.identity)
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getTemplate() {
      try {
        this.$store.dispatch("customer/setClientTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    advanceSearch() {
      this.getCustomer(this.search);
      this.advancedSearchPopup = false;
      this.clearSearch();
    },
    onClickAdvanceSearch() {
      this.advancedSearchPopup = true;
      this.clearSearch();
    },
    async performSearch() {
      const data = this.searchQuery;
      try {
        await this.$store.dispatch("customer/customerFullSearchAction", data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    clearSearch() {
      (this.loc = ""),
        (this.search = {
          firstName: "",
          lastName: "",
          city: "",
          email: "",
          phone: "",
          officeId: "",
          categoryType: "",
          externalId: "",
          limit: 1000,
        });
    },
  },
  watch: {
    searchOption() {
      this.searchdata = "";
      if (this.customerListToggleValue == true) {
        this.getCustomer(this.searchdata);
      }
    },
  },
  async mounted() {
    this.loading = true;
    if (this.customerListToggleValue == true) {
      await this.getCustomer(this.search);
    }
    await this.getTemplate();
    this.loading = false;
  },
};
</script>
<style lang="scss">
.vs-table--search {
  max-width: 100%;
}
.positive-balance {
  color: rgb(15, 205, 15);
}

.negative-balance {
  color: red;
}

.vs-search-categeory {
  margin-top: 17px;
}
.header--customerlist .vs-con-input-label {
  padding-top: 0px;
}

.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-warning {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.product-order-status.vs-chip-dark {
  background: #eee !important;
  border: 1px solid #f72121;
  color: #ea5455 !important;
}
.vue-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {
  width: 42%;
  left: 45px;
}
.vs-popup--close {
  background: #ff4040 !important;
}
.search-inp {
  margin-top: 0px !important;
}
.vs-input--input.hasIcon:not(.icon-after-input) + .vs-input--placeholder {
  padding-left: 2.5rem !important;
  font-size: 13px;
  letter-spacing: 0.005em;
  color: #777777;
  font-weight: 400;
}
.search-inp div span {
  color: #000;
}
@import "@/assets/scss/vuexy/extraComponents/autocomplete.scss";
.disabled-upload {
  display: none !important;
}
.min-w-100 {
  min-width: 130px;
}
.w-100 {
  width: 10rem;
}
::v-deep.input-span-placeholder {
  font-size: 10px;
}
.full-width-input {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1000px;
}
.full-search {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px;
}
</style>
